// What is Site Code: https://support.wix.com/en/article/corvid-working-in-the-code-panel


import wixWindow from 'wix-window';


$w.onReady(function () {
 if(wixWindow.formFactor === "Mobile"){
  $w("#languageSelector17").show();
 }
});


$w.onReady(function () {
	if(wixWindow.formFactor === "Mobile"){
  $w("#text60").show();
}
});


export function text10_mouseOut(event, $w) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w("#text10").html = `<h2 style = 'font-size:11px;font-family:avenir-lt-w01_35-light1475496,sans-serif;color:#959595'> ${$w("#text10").text}</h5>`;
}

export function text10_mouseIn(event) {
	$w("#text10").html = `<h2 style = 'font-size:11px;font-family:avenir-lt-w01_35-light1475496,sans-serif;color:000000;'  > ${$w("#text10").text}</h5>`;
}

export function text10_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
    wixWindow.openLightbox("Language_Popup");
}